<template>
    <div>
        <b-form-group v-if="fixedAmounts.length > 0">
            <b-form-radio-group
                stacked
                v-model="donationAmount"
                :options="fixedAmounts"
                :name="`ignore_this_field_${charity.id}`"
                @change="firstLoad"
            />
        </b-form-group>
        <b-form-group
            v-if="charity.allow_custom_amount"
            :label="label"
            :id="`amount_${charity.id}`"
        >
            <money
                class="form-control form-control-sm disabled"
                :class="{'is-invalid': meetsMinDonation}"
                :value="maskedDonationAmount"
                @input="maskedDonationAmountChanged"
                v-bind="money"
            ></money>
        </b-form-group>
        <slot :donation-amount="donationAmount"></slot>
    </div>
</template>

<script>
import BFormCheckbox from 'bootstrap-vue/es/components/form-checkbox/form-checkbox'
import BFormGroup from 'bootstrap-vue/es/components/form-group/form-group'
import BFormRadioGroup from 'bootstrap-vue/es/components/form-radio/form-radio-group'
import {Money} from 'v-money';

export default {
    components: {
        BFormCheckbox,
        BFormGroup,
        BFormRadioGroup,
        Money,
    },

    props: {
        charity: {
            type: Object,
            required: true,
        },
        value: {
            type: Number,
            required: false,
            default: 0,
        }
    },

    data() {
        return {
            donationAmount: this.value,
            money: {
                decimal: `.`,
                thousands: `,`,
                prefix: this.convertCurrencyCodeToPrefix(this.charity.currency),
                precision: 2,
                masked: false
            },
            noDonationText: this.charity.hasOwnProperty('field_mappings') && this.charity.field_mappings.length && this.charity.field_mappings.find(fieldMapping => fieldMapping.field_name === 'no_donation')
                ? this.charity.field_mappings.find(fieldMapping => fieldMapping.field_name === 'no_donation').translation
                : 'Clear',
            userClicked: false,
        }
    },
    computed: {
        fixedAmounts() {
            if (!this.charity.fixed_donation_amounts) return [];
            let
                noMinimumAmount = this.charity.minimum_amount === null || !parseInt(this.charity.minimum_amount),
                fixedAmounts = []
            ;

            fixedAmounts = this.charity.fixed_donation_amounts
                .map(fixedAmount => {
                    let text = fixedAmount.price_display;

                    if (fixedAmount.description) {
                        text += ` - ${fixedAmount.description}`;
                    }

                    return {
                        value: parseInt(fixedAmount.amount),
                        text,
                    };
                });

            if (noMinimumAmount && fixedAmounts.length > 0) {
                fixedAmounts
                    .push({
                        value: 0,
                        text: this.noDonationText,
                    });
            }

            return fixedAmounts;
        },
        label() {
            return this.fixedAmounts.length == 0 ? `Donation Amount` : `Other Amount`;
        },
        maskedDonationAmount() {
            return this.donationAmount > 0 ?
                parseFloat(this.donationAmount) / 100
                : 0;
        },
        meetsMinDonation() {
            return this.charity.minimum_amount && this.donationAmount < this.charity.minimum_amount;
        },
    },

    watch: {
        donationAmount(newVal) {
            this.$emit(`input`, newVal);
        },
    },

    methods: {
        convertCurrencyCodeToPrefix(code) {
            switch (code) {
                case `GBP`:
                    return `£`;
                case `EUR`:
                    return `€`;
                case `USD`:
                    return `$`;
            }
        },
        maskedDonationAmountChanged(donationAmountPoundsAndPence) {
            if (donationAmountPoundsAndPence > 0) {
                this.userClicked = true;
            }

            if (this.userClicked || this.fixedAmounts.length == 0) { //So that the radio are unchecked when the page first loads
                Object.assign(this, {
                    donationAmount: parseFloat(donationAmountPoundsAndPence) * 100,
                });
            }
        },
        firstLoad() {
            this.userClicked = true;
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Donations/Form/Amount.vue